import React from "react";
import { getDateFromEpoch, getDayAbbreviation, getMonthAbbreviation, getDateOrdinal } from "../../services/dateService";

export const TodoItemDate = ({ epoch, variant, widthOverride }) => {
    const dateFromEpoch = getDateFromEpoch(epoch);
    const day = getDayAbbreviation(dateFromEpoch.getDay());
    const date = dateFromEpoch.getDate();
    const month = getMonthAbbreviation(dateFromEpoch.getMonth());

    return (
        <span className={`font-bold sm:text-sm text-xs`}>
            {day} {date}{getDateOrdinal(date)} {month}
        </span>
    );
};
